import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SseNotificationComponent } from './sse-notification.component';
import { InstallTimerComponent } from './install-timer/install-timer.component';

@NgModule({
    declarations: [
        SseNotificationComponent
		, InstallTimerComponent
    ]
    , imports: [
        CommonModule
    ]
    , exports: [
		SseNotificationComponent
		, InstallTimerComponent
	]
})
export class SseNotificationModule { }
